export const SIGN_UP_REQUEST = 'auth/SIGN_UP_REQUEST';
export const LOGIN_REQUEST = 'auth/LOGIN_REQUEST';
export const LOGIN_WITH_TOKEN_REQUEST = 'auth/LOGIN_WITH_TOKEN_REQUEST';
export const LOGIN_WITH_PROVIDER_REQUEST = 'auth/LOGIN_WITH_PROVIDER_REQUEST';
export const REQUEST_CONFIRM_EMAIL = 'auth/REQUEST_CONFIRM_EMAIL';
export const RESET_PASSWORD_REQUEST = 'auth/RESET_PASSWORD_REQUEST';
export const CONFIRM_PASSWORD_REQUEST = 'auth/CONFIRM_PASSWORD_REQUEST';
export const REQUEST_LOGOUT = 'auth/REQUEST_LOGOUT';
export const PROFILE_SETUP_REQUEST = 'auth/PROFILE_SETUP_REQUEST';
export const REQUEST_CONNECT_STRIPE = 'auth/REQUEST_CONNECT_STRIPE';
export const REQUEST_CHECK_EMAIL = 'auth/REQUEST_CHECK_EMAIL';
export const REQUEST_CREATE_USER = 'auth/REQUEST_CREATE_USER';
export const REQUEST_UPGRADE_ACCOUNT = 'auth/REQUEST_UPGRADE_ACCOUNT';
export const REQUEST_GET_UPGRADE_ACCOUNT_PLAN = 'auth/REQUEST_GET_UPGRADE_ACCOUNT_PLAN';
